import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAccessibleOrganizationListQueryVariables = Types.Exact<{
  input: Types.GetAccessibleOrganizationListInput;
}>;

export type GetAccessibleOrganizationListQuery = {
  __typename?: 'Query';
  getAccessibleOrganizationList: {
    __typename?: 'GetAccessibleOrganizationListResponse';
    items: Array<{
      __typename?: 'GetAccessibleOrganizationListResponseOrganization';
      name: string;
      uuid: string;
    }>;
    pagination?: {
      __typename?: 'PaginationResponse';
      pageNumber: number;
      pageSize: number;
      total: number;
      totalPage: number;
    } | null;
  };
};

export const GetAccessibleOrganizationListDocument = gql`
  query GetAccessibleOrganizationList(
    $input: GetAccessibleOrganizationListInput!
  ) {
    getAccessibleOrganizationList(input: $input) {
      items {
        name
        uuid
      }
      pagination {
        pageNumber
        pageSize
        total
        totalPage
      }
    }
  }
`;
export function useGetAccessibleOrganizationListQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAccessibleOrganizationListQuery,
    GetAccessibleOrganizationListQueryVariables
  > &
    (
      | {
          variables: GetAccessibleOrganizationListQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccessibleOrganizationListQuery,
    GetAccessibleOrganizationListQueryVariables
  >(GetAccessibleOrganizationListDocument, options);
}
export function useGetAccessibleOrganizationListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccessibleOrganizationListQuery,
    GetAccessibleOrganizationListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccessibleOrganizationListQuery,
    GetAccessibleOrganizationListQueryVariables
  >(GetAccessibleOrganizationListDocument, options);
}
export function useGetAccessibleOrganizationListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAccessibleOrganizationListQuery,
        GetAccessibleOrganizationListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAccessibleOrganizationListQuery,
    GetAccessibleOrganizationListQueryVariables
  >(GetAccessibleOrganizationListDocument, options);
}
export type GetAccessibleOrganizationListQueryHookResult = ReturnType<
  typeof useGetAccessibleOrganizationListQuery
>;
export type GetAccessibleOrganizationListLazyQueryHookResult = ReturnType<
  typeof useGetAccessibleOrganizationListLazyQuery
>;
export type GetAccessibleOrganizationListSuspenseQueryHookResult = ReturnType<
  typeof useGetAccessibleOrganizationListSuspenseQuery
>;
export type GetAccessibleOrganizationListQueryResult = Apollo.QueryResult<
  GetAccessibleOrganizationListQuery,
  GetAccessibleOrganizationListQueryVariables
>;
export function refetchGetAccessibleOrganizationListQuery(
  variables: GetAccessibleOrganizationListQueryVariables,
) {
  return { query: GetAccessibleOrganizationListDocument, variables: variables };
}
